<template>
  <div class="prb-card">
    <div class="prb-wrapper">
      <p class="prb-status">
        {{ step }}<span class="prb-slash">/</span>{{ stepCount }}
      </p>
      <p><slot/></p>
    </div>

    <div class="prb">
      <div
        class="prb-fill"
        :style="{ width: progress + '%' }"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Progressbar',
  props: {
    step: {
      type: Number,
      required: true,
    },
    stepCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    progress() {
      return (100 / this.stepCount) * this.step;
    },
  },
};
</script>
